'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const baseUrl = '/'
// const baseUrl = '/SXH_Test/'

const path = require('path')

module.exports = {
	baseUrl,
  dev: {

    // Paths
    assetsSubDirectory: 'static',
    // assetsPublicPath: '/',
    assetsPublicPath: baseUrl,
    proxyTable: {},

    // Various Dev Server settings
    host: 'localhost', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    
    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
	// WARNING:
	// 如果网站项目不是部署到域名根目录，则需要将 assetsPublicPath 改为网站绝对路径，
	// 否则 vue-router 的异步加载组件 的路径会不正确。
	// 这个问题也可以由后端进行 apache 配置来解决，方法很简单（但我不知道怎么搞），比如：
	// 检测url是否有 /static/ ，如果有就替换路径为 https://baitong.quxun.tech/SXH_Test/static 这种，
	// 否则你会见到 https://baitong.quxun.tech/SXH_Test/productDetail/static/js/xxx.js 这种资源加载url 。
	// 话说要是 webpack的rquire() 能给个修改 url 的钩子就好了
    assetsPublicPath:"./",
    // assetsPublicPath: `https://baitong.quxun.tech${baseUrl}`,

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 21